/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";

import Button from "../../components/UI/Button/Button";
import useMakeRequest from "../../hooks/useMakeRequest";
import Preloader from "../../components/UI/Preloader/Preloader";

import classes from "./ChangePassword.module.sass";

function ChangePassword() {
  const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
  const [isRepeatPasswordVisible, setIsRepeatPasswordVisible] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [setParams, data, isLoading, hasError, error] = useMakeRequest();

  const onViewNewPass = () => {
    setIsNewPasswordVisible(!isNewPasswordVisible);
  };

  const onViewRepeatPass = () => {
    setIsRepeatPasswordVisible(!isRepeatPasswordVisible);
  };

  const validatePasswordForm = (values) => {
    const errors = {};

    const re = /(?=.*[0-9])(?=.*[a-z])[0-9a-zA-Z!@#$%^&*]{6,}/g;

    if (!values.newPassword) {
      errors.newPassword = "All fields are required";
    } else if (values.newPassword.length < 6) {
      errors.newPassword = "The minimum password length must be 6 characters";
    } else if (!values.newPassword.match(re)) {
      errors.newPassword =
        "Invalid new password. The password must contains numbers and letters";
    }

    if (!values.repeatPassword) {
      errors.repeatPassword = "All fields are required";
    } else if (!values.repeatPassword.match(re)) {
      errors.repeatPassword = "Invalid field repeat new password";
    } else if (values.repeatPassword !== values.newPassword) {
      errors.repeatPassword = "New passwords are different";
    }
    return errors;
  };

  const onSubmitForm = (values) => {
    setParams({
      c: "accountStore",
      a: "changePassword",
      p: { password_new: values.newPassword },
    });
  };

  useEffect(() => {
    if (data) {
      setIsSubmit(false);
    }
  }, [data]);

  return (
    <article className={classes.changePassword}>
      <div className={classes.changePassword_block}>
        <section className={classes.changePassword_title}>
          <h3>Change Password</h3>
        </section>
        <Formik
          initialValues={{
            newPassword: "",
            repeatPassword: "",
          }}
          validate={(values) => validatePasswordForm(values)}
          onSubmit={(values) => onSubmitForm(values)}
          validateOnChange={!!isSubmit}
          validateOnBlur={!!isSubmit}
        >
          {({ isSubmitting, errors, isValid }) => {
            return (
              <>
                <Form className={classes.changePasswordForm}>
                  {!isValid && errors ? (
                    <div
                      className={`${classes.changePassword_message} ${classes.changePassword_message_error}`}
                    >
                      {errors.newPassword || errors.repeatPassword}
                    </div>
                  ) : (isSubmitting && !error && isLoading) ||
                    (isSubmitting && error && hasError && isLoading) ? (
                    <div
                      className={`${classes.changePassword_message} ${classes.changePassword_preloader}`}
                    >
                      <Preloader />
                    </div>
                  ) : isSubmitting && !error && data ? (
                    <div
                      className={`${classes.changePassword_message} ${classes.changePassword_message_success}`}
                    >
                      Password changed successfully!
                    </div>
                  ) : error && hasError ? (
                    <div
                      className={`${classes.changePassword_message} ${classes.changePassword_message_error}`}
                    >
                      {error}
                    </div>
                  ) : (
                    <div className={classes.changePassword_message}>
                      Please note when changing your password, we ask you to set
                      yourself a secure password of at least 6 characters that
                      contain both letters and numbers. This is your own safety.
                    </div>
                  )}
                  <div className={classes.changePasswordForm_wrap}>
                    <div
                      className={[classes.changePasswordForm_line].join(" ")}
                    >
                      <label>New Password</label>
                      <div className={classes.changePasswordForm_input}>
                        <Field
                          name="newPassword"
                          type={isNewPasswordVisible ? "text" : "password"}
                          className={
                            errors.newPassword
                              ? "input-full input-full_error"
                              : "input-full"
                          }
                        />
                        <span
                          onClick={onViewNewPass}
                          aria-hidden="true"
                          className={
                            isNewPasswordVisible
                              ? `${classes.passVisibility} ${classes.passVisibility_v}`
                              : classes.passVisibility
                          }
                        />
                      </div>
                    </div>
                    <div
                      className={[classes.changePasswordForm_line].join(" ")}
                    >
                      <label>Repeat New Password</label>
                      <div className={classes.changePasswordForm_input}>
                        <Field
                          name="repeatPassword"
                          type={isRepeatPasswordVisible ? "text" : "password"}
                          className={
                            errors.repeatPassword
                              ? "input-full input-full_error"
                              : "input-full"
                          }
                        />
                        <span
                          onClick={onViewRepeatPass}
                          aria-hidden="true"
                          className={
                            isRepeatPasswordVisible
                              ? [
                                  classes.passVisibility,
                                  classes.passVisibility_v,
                                ].join(" ")
                              : classes.passVisibility
                          }
                        />
                      </div>
                    </div>
                    <div className={classes.changePasswordForm_line}>
                      <label />
                      <Button
                        className="btn-transparent btn-blue"
                        type="submit"
                        disabled={isSubmitting}
                        onClick={() => setIsSubmit(true)}
                      >
                        Change Password
                      </Button>
                    </div>
                  </div>
                </Form>
              </>
            );
          }}
        </Formik>
      </div>
    </article>
  );
}

export default ChangePassword;
